import { Avatar, Badge, Table, Group, Text, Loader, HoverCard } from '@mantine/core';
import { User } from '../../pages';
import { formatDateInNepalTimezone, NEPAL_TIMEZONE } from '../../utils/timezone';
import { CopyableId } from '../copyableId/CopyableId';

export function StampsTable({ data, loading, error }) {
    if (loading) {
        return <Loader />;
    }

    // refactor data 
    data = data.map((item) => {
        const isNewUser = item.user?.createdAt &&
            (() => {
                const createdAt = item.user.createdAt.toDate();
                // Get today's date in Nepal timezone
                const nepalToday = new Date().toLocaleDateString('en-CA', { timeZone: NEPAL_TIMEZONE });
                const createdAtNepal = createdAt.toLocaleDateString('en-CA', { timeZone: NEPAL_TIMEZONE });
                
                return nepalToday === createdAtNepal;
            })();

        return {
            id: item.userId,
            stampId: item.id,
            name: item.user?.name +" (v."+(item.user.versionCode)+")" || 'Unknown',
            phone: item.user?.phone || 'Unknown',
            image: item.user?.image,
            date: item.stampedDate.seconds,
            stampCount: item.count,
            brand: item.brand?.name || 'Unknown',
            isNewUser: isNewUser,
        };
    });

    const rows = data.map((item, index) => (
        <Table.Tr key={index}>
            <Table.Td>
                <CopyableId id={item.stampId || item.id} label={item.stampId ? 'Stamp ID' : 'User ID'} />
            </Table.Td>
            <Table.Td>
                <Group gap="sm">
                    <HoverCard shadow="md" openDelay={600} radius={20}>
                        <HoverCard.Target>
                            <Group gap="sm" style={{ cursor: 'pointer' }}>
                                <div style={{ position: 'relative', width: 30, height: 30 }}>
                                    <Avatar size={30} src={item.image} radius={30} />
                                    {item.isNewUser && (
                                        <Badge
                                            color="blue"
                                            variant="filled"
                                            radius="xl"
                                            style={{
                                                position: 'absolute',
                                                top: -2,
                                                right: -2,
                                                width: 10,
                                                height: 10,
                                                minWidth: 8,
                                                minHeight: 8,
                                                padding: 0,
                                            }}
                                        />
                                    )}
                                </div>

                                <Text fz="sm" fw={500}>
                                    {item.name}
                                </Text>
                            </Group>
                        </HoverCard.Target>
                        <HoverCard.Dropdown>
                            <User hoverCard={true} hoverId={item.id} />
                        </HoverCard.Dropdown>
                    </HoverCard>
                </Group>
            </Table.Td>

            <Table.Td>
                <Text fz="sm">{item.phone}</Text>
            </Table.Td>

            <Table.Td>
                <Text fz="sm">
                    {formatDateInNepalTimezone(new Date(item.date * 1000), {
                        dateStyle: 'short',
                        timeStyle: 'short'
                    })} (UTC+5:45)
                </Text>
            </Table.Td>

            <Table.Td>
                <Text fz="sm">{item.brand}</Text>
            </Table.Td>

            <Table.Td>
                <Badge variant="dark" size='lg'>
                    {item.stampCount}
                </Badge>
            </Table.Td>

        </Table.Tr>
    ));

    return (
        <>
            <Table.ScrollContainer minWidth={800}>
                <Table verticalSpacing="sm">
                    <Table.Thead>
                        <Table.Tr>
                            <Table.Th>ID</Table.Th>
                            <Table.Th>User</Table.Th>
                            <Table.Th>Phone</Table.Th>
                            <Table.Th>Date</Table.Th>
                            <Table.Th>Brand</Table.Th>
                            <Table.Th>Stamps</Table.Th>
                        </Table.Tr>
                    </Table.Thead>
                    <Table.Tbody>{rows}</Table.Tbody>
                </Table>
            </Table.ScrollContainer>
        </>
    );
}
